import React, { useState, useEffect, useContext } from 'react'
import { withI18n } from '@lingui/react'
import PropTypes from 'prop-types'
import { LocalisationContext } from '@yoti-web-share/localisation'
import getUrlQueryParams from '../../utils/getUrlQueryParams'
import ParametersContext from './ParametersContext'

const validateLearnMoreParams = (params) => {
  if (!params) return false
  const { clientSdkId, scenarioId, referrer } = params
  if (!clientSdkId || !scenarioId || !referrer) return false
  return true
}

const extractQueryParams = () => {
  const {
    data,
    ...expandedParams
  } = getUrlQueryParams(window.location.href)
  let queryParams

  if (data) {
    // encoded data mode
    queryParams = JSON.parse(decodeURIComponent(atob(data)))
  } else if (expandedParams) {
    // expanded params mode
    queryParams = expandedParams
  }
  return queryParams
}

const ParametersProvider = ({ children }) => {
  const [learnMoreParams, setLearnMoreParams] = useState()
  const [error, setError] = useState()
  const { changeLocale } = useContext(LocalisationContext)

  useEffect(() => {
    try {
      const params = extractQueryParams()
      const learnMoreParamsExist = validateLearnMoreParams(params)

      if (learnMoreParamsExist) {
        changeLocale(params.language)
        setLearnMoreParams(params)
      } else {
        setError(new Error('Learn more parameters are not provided'))
      }
    } catch (e) {
      setError(e)
    }
  }, [changeLocale])

  if (error) {
    throw error
  }

  if (learnMoreParams) {
    return (
      <ParametersContext.Provider value={learnMoreParams}>
        {children}
      </ParametersContext.Provider>
    )
  }
  return null
}

ParametersProvider.defaultProps = {
  children: null
}

ParametersProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element
  ])
}

export default withI18n()(ParametersProvider)
